import {create} from "zustand"
import axios from "axios";


export const usePumpStore = create((set) => ({
    userId: 0,
    language: 'RU',
    screen: 'login',
    level: 1,
    taskType: 'task',
    task: {
        options: [],
        title: '',
        price: 0,
        image: '',
        type: ''
    },
    taskNumber: 1,
    tasksCount: 0,
    balance: 0,
    equity: 0,
    winAmount: 0,
    winAmountClass: 'win-amount',
    equityClass: 'text-wrapper',
    equityTitleClass: 'eqdiv',
    extTime: 57600,
    status: 'idle',
    selectedAnswer: '',
    answerChosen: false,
    isExploding: false,
    screenStatus: 'idle',
    correctAnswer: '',
    artifacts: [],
    screenLayout: 'task',
    difficulty: 1,
    showArtDialog: '',
    history: [],
    showChests: false,
    chestsType: 'first',
    myTasks: [],
    appInitData: {},
    showHeal: false,
    showShield: false,
    activeCount: 0,
    basePrice: 0,
    setScreen: (screen) => set({screen: screen}),
    setUserId: (userId) => set({userId: userId}),
    setLanguage: (language) => set({language: language}),
    setTask: (task) => set({task: task}),
    setSelectedAnswer: (selectedAnswer) => set({selectedAnswer: selectedAnswer}),
    setAnswerChosen: (answerChosen) => set({answerChosen: answerChosen}),
    setWinAmount: (winAmount) => set({winAmount: winAmount}),
    setStatus: (status) => set({status: status}),
    setIsExploding: (isExploding) => set({isExploding: isExploding}),
    setWinAmountClass: (winAmountClass) => set({winAmountClass: winAmountClass}),
    setEquity: (equity) => set({equity: equity.toFixed(2)}),
    setBalance: (balance) => set({balance: balance}),
    setTaskNumber: (taskNumber) => set({taskNumber: taskNumber}),
    setTasksCount: (tasksCount) => set({tasksCount: tasksCount}),
    setEquityClass: (equityClass) => set({equityClass: equityClass}),
    setEquityTitleClass: (equityTitleClass) => set({equityTitleClass:equityTitleClass}),
    setTime: (newTime) => set({extTime: newTime}),
    setLevel: (level) => set({level: level}),
    setScreenStatus: (screenStatus) => set({screenStatus: screenStatus}),
    setCorrectAnswer: (correctAnswer) => set({correctAnswer: correctAnswer}),
    setArtifacts: (artifacts) => set({artifacts: artifacts}),
    setScreenLayout: (screenLayout) => set({screenLayout: screenLayout}),
    setDifficulty: (difficulty) => set({difficulty: difficulty}),
    setShowArtDialog: (showArtDialog) => set({showArtDialog: showArtDialog}),
    setHistory: (history) => set({history: history}),
    setShowChests: (showChests) => set({showChests: showChests}),
    setChestsType: (chestsType) => set({chestsType: chestsType}),
    setMyTasks: (myTasks) => set({myTasks: myTasks}),
    setAppInitData: (appInitData) => set({appInitData: appInitData}),
    setShowHeal: (showHeal) => set({showHeal: showHeal}),
    setShowShield: (showShield) => set({showShield: showShield}),
    setActiveCount: (activeCount) => set({activeCount: activeCount}),
    setBasePrice: (basePrice) => set({basePrice: basePrice})
}))